const es = {
  'cancelSubscription.title': '¿Deseas cancelar tu suscripción?',
  'cancelSubscription.description': 'Al hacer esto, perderás el precio especial que obtuviste por el uso del cupón.',
  'cancelSubscription.understandButton': 'Entiendo y deseo continuar con la cancelación de mi subscripción.',
  'cancelSubscription.description.apple': 'Para completar el proceso, deberás cancelar la subscripción en tu dispositivo, puedes seguir las siguientes instrucciones: https://support.apple.com/es-mx/HT202039.',
};

export default es;
